import React, { useState, Fragment, useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import { useSelector } from 'react-redux';
import './ReassignQueuePage.scss'
import Section from '../../components/layout/Section';
import ReassignAssociateTable from './components/reassign/ReassignAssociateTable';
import HrbTranslate from '../../components/language/HrbTranslate';
import HelpLink from '../../components/library/common/HelpLink';
import ReassignTableColumnHeader from './components/reassign/ReassignTableColumnHeader'
import Breadcrumb from '../../components/common/Breadcrumb/Breadcrumb';
import { Permissions } from '../../app/services/Permissions';

const ReassignQueuePage = () => {
    const location = useLocation();
    const [officeId, setOfficeId] = useState(null)
    const { selectedTicketIds, parentOfficeId, parentAssociateFirstName, parentAssociateId, isAssociateQueue, pageSelections } = location.state ?? {}; 
    const [selectedAssociateId, setSelectedAssociateId] = useState(null);
    const [selectedAssociateFirstName, setSelectedAssociateFirstName] = useState(null);
    const [selectedAssociateName, setSelectedAssociateName] = useState(null);
    const hasViewDistrictOfficesPermission = useSelector(state => (state.accountData.permissions || []).includes(Permissions.VIEW_DISTRICT_OFFICES));
    localStorage.setItem('parentAssociateId', parentAssociateId);

    const handleSelectedOfficeChange = (selectedOfficeId) => {
        setOfficeId(selectedOfficeId)
        setSelectedAssociateId(null);
    };

    const handleAssociateSelect = (employeeId, firstName, lastName) => {
        setSelectedAssociateId(employeeId);
        setSelectedAssociateFirstName(firstName);
        setSelectedAssociateName(firstName + ' ' + lastName);
    }
    
    return (
        <div className="content-grid queue" >
            <Section sectionId='section-queue-summary' className='white'>
                <Fragment>
                    <div className='columns '>
                        <div className='ml-5'>
                            {isAssociateQueue &&
                                <Breadcrumb
                                    paths={[
                                        { href: '/', label: <HrbTranslate text='Breadcrumbs.HomePage' /> },
                                        { href: `/offices/${parentOfficeId}`, label: <HrbTranslate text='Breadcrumbs.OfficesPage' params={{ OfficeId: parentOfficeId }} /> },
                                        { href: `/queue/${parentAssociateId}`, label: <HrbTranslate text='Breadcrumbs.AssociateTicketsPage' params={{ AssociateFirstName: parentAssociateFirstName }} />, state: { parentOfficeId } },
                                        { label: <HrbTranslate text='Breadcrumbs.ReassignPage' /> }
                                    ]}
                                />}
                            {!isAssociateQueue &&
                                <Breadcrumb
                                    paths={[
                                        { href: hasViewDistrictOfficesPermission ? '/queue' : '/home', label: <HrbTranslate text={hasViewDistrictOfficesPermission ? 'Breadcrumbs.MyTicketsPage' : 'Breadcrumbs.HomePage' } /> },
                                        { label: <HrbTranslate text='Breadcrumbs.ReassignPage' /> }
                                    ]}
                                />}
                        </div>
                            
                    </div>
                </Fragment>
            </Section>
            <Section sectionId='section-queue' className='light-functional-grey'>
                <div className="columns">
                    <div className='column is-7 ml-5'>
                        <h3><HrbTranslate text='QueuePage.Labels.ReassignPageHeader' params={{ ticketsCount: selectedTicketIds?.length }} /></h3>
                    </div>
                    <div className='column is-2' style={{ marginLeft: '25%' }}>
                        <HelpLink helpKey='0ProSupport/VDOPro/BulkReassignment.htm' />
                    </div>
                </div>
                <div className='reassign-table'>
                    <ReassignTableColumnHeader
                        onSelectedOfficeChange={handleSelectedOfficeChange}
                        selectedAssociateId={selectedAssociateId}
                        selectedAssociateOfficeId={officeId}
                        selectedAssociateFirstName={selectedAssociateFirstName}
                        selectedAssociateName={selectedAssociateName}
                        selectedTicketIds={selectedTicketIds}
                        hasViewDistrictOfficesPermission={hasViewDistrictOfficesPermission}
                    />
                    <ReassignAssociateTable selectedOffice={officeId} handleAssociateSelect={handleAssociateSelect} />
                </div>
            </Section>
        </div>
    );
}

export default ReassignQueuePage
